import React, { useEffect, useState } from 'react';

import { ValueBox, ValueBoxGroupOptions, ValueStepper } from '@candu-ai/craft/ui';
import { getCssResetStyleMessage, StylesHierarchy } from 'craft/hooks';
import { useViewportBreakpoint } from 'craft/state';

interface Props {
  cssProps: Record<string, unknown>;
  setCss: (e: Record<string, unknown>) => void;
  stylesHierarchy: StylesHierarchy;
  isInGroup?: ValueBoxGroupOptions;
  variant?: string;
}

export const TextSize = ({ cssProps, setCss, isInGroup, stylesHierarchy, variant }: Props) => {
  const { fontSize } = cssProps;
  const viewport = useViewportBreakpoint();

  const defaultValue = parseFloat((stylesHierarchy?.fontSize?.fallbackValue || '') as string);
  const [inputValue, setInputValue] = useState<number | undefined>(
    fontSize ? parseFloat(fontSize as string) : defaultValue,
  );

  useEffect(() => {
    setInputValue(fontSize ? parseFloat(fontSize as string) : defaultValue);
  }, [viewport, variant]);

  return (
    <ValueBox label="Font Size" isInGroup={isInGroup}>
      <ValueStepper
        scale="small"
        editable
        minValue={1}
        maxValue={999}
        step={1}
        onResetTooltip={getCssResetStyleMessage(stylesHierarchy?.fontSize?.fallbackStyle)}
        onReset={
          !!fontSize && inputValue !== defaultValue
            ? () => {
                setInputValue(defaultValue);
                setCss({ fontSize: undefined });
              }
            : undefined
        }
        onBlur={() => {
          if (typeof inputValue === 'undefined') {
            setInputValue(defaultValue);
          }
        }}
        onChange={(newValue?: number) => {
          setInputValue(newValue);
          if (newValue === defaultValue) {
            setCss({ fontSize: undefined });
            return;
          }
          // only trigger change when there is no value or the value is within the accepted range
          if (typeof newValue === 'undefined' || (newValue >= 1 && newValue <= 999)) {
            setCss({ fontSize: typeof newValue !== 'undefined' ? `${newValue}px` : newValue });
          }
        }}
        valueSuffix="px"
        value={inputValue}
      />
    </ValueBox>
  );
};
